// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0953720f","977":"70a1ba99"}[chunkId] + ".chunk.js";
};